import script from "./XiamenLoginComponents.vue?vue&type=script&setup=true&lang=js"
export * from "./XiamenLoginComponents.vue?vue&type=script&setup=true&lang=js"

import "./XiamenLoginComponents.vue?vue&type=style&index=0&id=019543c5&lang=less"

const __exports__ = script;

export default __exports__